import * as React from 'react'
import styled from '@emotion/styled'
import { CssProp } from '../../typescript/emotion'
import { ClickEvent } from '../../typescript/utility'
import { ButtonBase } from '../../common/components/ButtonBase'
import { theme } from '../../styles/theme'
import { Orientation } from '../hooks/useGetShortestRotationFromOrientation'

type Props = {
  className?: string
  orientation?: Orientation
  color?: string
  onClick?: (e: ClickEvent) => void
  style?: React.CSSProperties
  buttonStyle?: React.CSSProperties
  cssProp?: CssProp
  buttonCssProp?: CssProp
  buttonProps?: React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>
  size?: number
}

const styles = {
  left: { transform: 'rotate(0deg)' },
  up: { transform: 'rotate(90deg)' },
  right: { transform: 'rotate(180deg)' },
  down: { transform: 'rotate(270deg)' },
}

// TODO look into how to use the babel emotion plugin but have the prop actually passed through if the component is a
// Custom component

// TODO merge onclick, buttonProps, css, etc.
const ConditionalButton = ({
  onClick,
  children,
  buttonStyle,
  buttonCssProp,
  buttonProps,
  orientation,
}: React.PropsWithChildren<
  Pick<Props, 'onClick' | 'buttonStyle' | 'buttonCssProp' | 'buttonProps'> & { orientation: string }
>) =>
  typeof onClick === 'function' ? (
    <ButtonBase
      onClick={onClick}
      style={buttonStyle}
      css={buttonCssProp}
      type={'button'}
      {...buttonProps}
      aria-label={orientation}
    >
      {children}
    </ButtonBase>
  ) : (
    <>{children}</>
  )

const Svg = styled.svg<{ transition?: string }>`
  transition: ${(p) => `transform 0.1s ease-out${p.transition ? `, ${p.transition}` : ''}`};

  path {
    transition: stroke 0.3s;
  }
`

/**
 * @deprecated use NavigationArrow instead moving forward
 */
export function LEGACY_Chevron({
  orientation = 'down',
  color = theme.colors.grayCoal,
  onClick,
  style,
  buttonStyle,
  cssProp,
  buttonCssProp,
  buttonProps,
  className,
  size,
}: Props) {
  const width = size ?? 8
  const height = width * (15 / 8)
  return (
    <ConditionalButton
      onClick={onClick}
      buttonStyle={buttonStyle}
      buttonCssProp={buttonCssProp}
      buttonProps={buttonProps}
      orientation={orientation}
    >
      <Svg
        width={width}
        height={height}
        viewBox="0 0 8 15"
        fill="none"
        className={className}
        css={cssProp}
        style={{ minWidth: width, minHeight: height, ...styles[orientation], ...style }}
      >
        <path d="M7 1L1 7.5L7 14" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </Svg>
    </ConditionalButton>
  )
}
